import styled from 'styled-components';

export const FlagNumber = styled.div`
  margin: -0.2rem 0 0;
  font-size: 1.5rem;
  margin-right: 0.35rem;
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.heavy};
`;
